module.exports = __webpack_public_path__ + "static/media/55_000054.cad21926.jpg";